<project-details-breadcrumb-version-header
  [hidden]="status == STATUS_FILE_NOT_FOUND || status == STATUS_NOT_FOUND"
  [project]="project"
  [version]="version"
  [exclude]="excludedLabels"
  [title]="'PREVIEW'"
  [breadcrumbs]="breadcrumbs"
></project-details-breadcrumb-version-header>


<div class="loader">
  <div class="dimmed" [hidden]="status != STATUS_LOADING">
    <div class="dimmed_flex">
      <div class="dimmed_content dimmed_versions">
        <div class="dimmed_title"></div>
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_subtitle"></div>
      </div>
      <div class="dimmed_status"></div>
    </div>
  </div>
</div>

<div *ngIf="status == STATUS_DONE" class="version">
    <versions-details-content-preview-file-main
        [version]="version"
        [file]="file"
        [menu]="menu"
        (menuClick)="onMenuClick($event)"
        (actionDownloadClick)="onActionDownloadClick($event)"
    ></versions-details-content-preview-file-main>
</div>
<div class="version-details-forbidden"  *ngIf="status == STATUS_NOT_ALLOWED && version != null">
  <core-versions-detail-box
      [version]="version"
  ></core-versions-detail-box>
  <core-helpers-box-alert-message-icon
    [text]="'You don’t have permission to see this artwork'"
    [icon]="'alert'"
  ></core-helpers-box-alert-message-icon>
</div>
<div *ngIf="status == STATUS_FILE_NOT_FOUND" class="">
  <core-helpers-box-alert-message-icon
      [text]="'This file does not exist.'"
      [icon]="'alert'"
    ></core-helpers-box-alert-message-icon>
</div>

<core-helpers-box-http-error
    *ngIf="status == STATUS_NOT_FOUND"
    [code]="404"
    [message]="'Not found.'"
></core-helpers-box-http-error>
